module.exports = require("@slack/client");


//////////////////
// WEBPACK FOOTER
// external "@slack/client"
// module id = 10
// module chunks = 0